(function () {
  var d = document;
  d.documentElement.classList.add('js');

  // Scroll reveals — same 16px rise the React build used.
  function armReveals() {
    var els = [].slice.call(d.querySelectorAll('.reveal'));
    if (!els.length) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !window.IntersectionObserver) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  // Mobile nav toggle.
  function armNav() {
    var btn = d.querySelector('[aria-controls="mobile-nav"]');
    var sheet = d.getElementById('mobile-nav');
    if (!btn || !sheet) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      btn.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
      if (open) { sheet.setAttribute('hidden', ''); d.body.style.overflow = ''; }
      else { sheet.removeAttribute('hidden'); d.body.style.overflow = 'hidden'; }
      var bars = btn.querySelectorAll('span span');
      if (bars.length === 2) {
        bars[0].className = open
          ? 'absolute left-0 block h-px w-5 bg-bone transition-transform duration-300 top-0'
          : 'absolute left-0 block h-px w-5 bg-bone transition-transform duration-300 top-1.5 rotate-45';
        bars[1].className = open
          ? 'absolute left-0 block h-px w-5 bg-bone transition-transform duration-300 top-3'
          : 'absolute left-0 block h-px w-5 bg-bone transition-transform duration-300 top-1.5 -rotate-45';
      }
    });
  }

  // Cal.com inline embed. The React CalEmbed component does not survive this
  // export (no React here), so its bootstrap is reproduced verbatim. Keyed off
  // [data-cal-link], which components/CalEmbed.tsx renders.
  //
  // embed.js does NOT define window.Cal itself — it expects this queueing stub
  // to exist first, and throws "Cal is not defined" without it.
  function armCal() {
    var host = d.querySelector('[data-cal-link]');
    if (!host) return;
    var link = host.getAttribute('data-cal-link');
    if (!link) return;

    (function (C, A, L) {
      var p = function (a, ar) { a.q.push(ar); };
      C.Cal = C.Cal || function () {
        var cal = C.Cal, ar = arguments;
        if (!cal.loaded) {
          cal.ns = {}; cal.q = cal.q || [];
          d.head.appendChild(d.createElement('script')).src = A;
          cal.loaded = true;
        }
        if (ar[0] === L) {
          var api = function () { p(api, arguments); };
          api.q = api.q || []; p(cal, ar); return;
        }
        p(cal, ar);
      };
    })(window, 'https://app.cal.com/embed/embed.js', 'init');

    window.Cal('init', { origin: 'https://cal.com' });
    window.Cal('inline', { elementOrSelector: host, calLink: link, layout: 'month_view' });
    window.Cal('ui', { theme: 'dark', layout: 'month_view' });

    // Fallback if the SDK is blocked, so nobody stares at an empty box.
    setTimeout(function () {
      if (!host.querySelector('iframe')) {
        host.innerHTML =
          '<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;' +
          'gap:16px;min-height:320px;padding:32px;text-align:center">' +
          '<p class="lab" style="color:#EDEAE3">Calendar didn\u2019t load</p>' +
          '<a class="lab" style="display:inline-flex;min-height:48px;align-items:center;' +
          'padding:0 24px;border:1px solid #EDEAE3;color:#EDEAE3;text-decoration:none" ' +
          'href="https://cal.com/' + link + '" target="_blank" rel="noopener noreferrer">' +
          'Open booking page</a></div>';
      }
    }, 12000);
  }

  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', function () { armReveals(); armNav(); armCal(); });
  } else { armReveals(); armNav(); armCal(); }
})();